{
  "version": 1,
  "asset_id": "7a2c679a-5dc8-4c3e-abb0-5558465d7b9d",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/7a2c679a-5dc8-4c3e-abb0-5558465d7b9d/rekomendacja-mastermind.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/7a2c679a-5dc8-4c3e-abb0-5558465d7b9d/rekomendacja-mastermind.jpg",
  "original_filename": "rekomendacja-mastermind.jpg",
  "size": 194010,
  "content_type": "image/jpeg",
  "created_at": "2026-09-22T14:21:20Z"
}
